import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Typography, Grid, Button } from '@material-ui/core'
import LoginBox from '../Auth/connected/LoginCnn';
import qmoLogo from '../scss/img/qmo_logo.png'
import awtLogo from '../scss/img/AWT_logo_small.png'

type PropsType = RouteComponentProps<any>

class LoginView extends Component<PropsType> {
    render() {
        return (
            <div>
                <div style={{ textAlign: 'center', paddingTop: '10px', paddingBottom: '0px' }}>
                    <img alt='' style={{ marginBottom: '10px', maxHeight: '200px' }} src={qmoLogo}></img>
                    <Typography variant="h2">Sign in</Typography>
                </div>

                <LoginBox />

                <Grid container style={{ textAlign: 'center' }}>
                    <Grid item xs={12} sm={12}>
                        <div style={{ padding: '10px 0 10px 0' }}>
                            <Typography variant="button" >OR</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={4}></Grid>
                    <Grid item xs={12} sm={4}>
                        <Button variant="outlined" color="primary" style={{ cursor: 'pointer', width: '100%' }} onClick={() => this.props.history.push("/SignUp")}>Sign up</Button>
                    </Grid>
                    <Grid item xs={12} sm={4}></Grid>

                    
                    <Grid item xs={12}>
                    <br/>
                    <img src={awtLogo} />    
                    </Grid>

                </Grid>
            </div>
        );
    }
}

export default withRouter(LoginView);